import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { OfferPackageOptionView, getCheapestSelectedPackageOption } from 'selectors/offerPage/offerPageSelectors'
import { useAppSelector } from 'hooks/reduxHooks'

export const useOfferPageRate = (state: OfferPageState): OfferPackageOptionView | undefined => {
  const packageView: OfferPackageOptionView | undefined = useAppSelector(
    (appState) => getCheapestSelectedPackageOption(appState, state),
  )
  if (!packageView) return

  return {
    ...packageView,
    hotelPrice: packageView.hotelPrice + (packageView.propertyFees ?? 0),
  }
}
